module.exports = __webpack_public_path__ + "a7a5dd52ecfce7b94c0d170a6a767a6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_large_x1/public/history/2.jpg
// module id = 251
// module chunks = 0